import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  RAVEN,
  SOLITUDE,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  select: {
    width: '100%',
    minWidth: 180,

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  input: {
    '& > div': {
      borderColor: 'transparent',
      '& > input': {
        fontFamily: URBANIST,
        color: MIDNIGHT_EXPRESS,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '160%',
      },
    },
  },
  datePicker: {
    '& > div': {
      border: '2px solid transparent',
    },
  },
  errorBlock: {
    margin: 20,
  },
  buttonsContainer: {
    position: 'fixed',
    width: '30%',
    bottom: 0,
    background: WHITE,
    borderTop: `1px solid ${GAINSBORO_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 -10px',
    padding: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  multilineInput: {
    color: MIDNIGHT_EXPRESS,
    fontSize: 14,
    fontFamily: URBANIST,
    fontWeight: 500,
    lineHeight: '160%',
  },
  addPrice: {
    fontFamily: URBANIST,
    fontSize: 14,
    color: NEON_BLUE_LIGHT,
    cursor: 'pointer',
    marginTop: 12,
  },
  attribute: {
    borderBottom: `1px solid ${NEON_BLUE_LIGHT}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  attributeHeader: {
    borderBottom: `1px solid ${NEON_BLUE_LIGHT}`,
    paddingBottom: 10,
  },
  attributeBlock: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 5,
    paddingBottom: 5,
    '& > span': {
      fontFamily: URBANIST,
      fontSize: 14,
      color: RAVEN,
    },
  },
  removePriceIcon: {
    cursor: 'pointer',
    marginLeft: 10,
    minWidth: 20,
    minHeight: 20,
  },
  price: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
  },
  partnerDestination: {
    width: '100%',
    padding: 20,
    position: 'relative',
    cursor: 'pointer',
    display: 'inline-block',
    marginTop: 12,
    border: `1px solid ${SOLITUDE}`,
    borderRadius: 3,
  },
  checkbox: {
    padding: 2.5,
  },
}))

export default useStyles
